import React from 'react';
import { isReactNative, SimpleBlock, useShowContextRequired } from 'ui-builder';
import { ExternalLink, Person, TeamPermission } from 'nekst-api';
import { FubIntegrationToggleWrapper } from 'feature-toggle';
import { FubConnectionLogo } from './FubConnectionLogo';

import styles from './FubConnectionLogo.module.scss';
import { AccessChecker } from 'authorization-scope';

function FubConnectionStatusBadge(
  props: {
    externalLink: ExternalLink;
  }
) {
  if (props.externalLink.isConflicting) {
    return (
      <SimpleBlock className={styles.statusBadge}>

      </SimpleBlock>
    );
  } else {
    return null;
  }

}

export function FubConnectionLogoFieldImpl() {
  const showContext = useShowContextRequired<Person>();

  if (showContext.data.externalLinks.length) {
    const externalLink = showContext.data.externalLinks[0];

    let title = `FUB: ${externalLink._contactName}`;
    if (externalLink._contactEmail) {
      title += ` (${externalLink._contactEmail})`;
    }

    return (
      <SimpleBlock
        className={styles.logoBlock}
        title={
          externalLink.isConflicting
            ? 'Contact syncing is currently disabled. Please visit the Contact page to resolve the conflict.'
            : undefined
        }
      >
        <FubConnectionLogo
          title={title}
          onClick={!isReactNative() ? () => {
            window.open(externalLink._externalProfileUrl, '_blank');
          } : undefined}
        />
        <FubConnectionStatusBadge externalLink={externalLink} />
      </SimpleBlock>
    );
  } else {
    return null;
  }
}

export function FubConnectionLogoField() {
  return (
    <FubIntegrationToggleWrapper>
      <AccessChecker permissionToCheck={TeamPermission.READ_FUB_CONNECTION}>
        <FubConnectionLogoFieldImpl />
      </AccessChecker>
    </FubIntegrationToggleWrapper>
  );
}
